import styled from 'styled-components'

export const LanguagePickerContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(5, auto);
  grid-template-columns: repeat(3, 200px);
  grid-auto-flow: column;
  row-gap: 10px;
  column-gap: 40px;
  margin-top: 15px;

  > *:first-of-type {
    margin-top: 0;
  }

  > *:last-of-type {
    margin-bottom: 0;
  }
`
